import cn from 'classnames';
// Context
import { SocialAccount } from 'context/OnboardingContext';
// Helpers
import {
  mapSocialPlatformToIcon,
  mapSocialPlatformToLabel,
} from 'helpers/socials';
// Ui
import Text from 'ui3/Text/Text';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './SocialsRow.module.scss';

type SocialsRowProps = {
  socialAccount: SocialAccount;
  firstRow?: boolean;
  lastRow?: boolean;
  onRemove: () => void;
  disabled?: boolean;
  useOldIcon?: boolean;
};

const SocialsRow = ({
  socialAccount,
  firstRow,
  lastRow,
  onRemove,
  disabled = false,
  useOldIcon = false,
}: SocialsRowProps) => {
  return (
    <div
      className={cn(styles.root, {
        [styles.firstRow]: firstRow,
        [styles.lastRow]: lastRow,
      })}
    >
      <div className={styles.content}>
        <div>
          <MillionsIcon
            className={cn({ [styles.disabled]: disabled })}
            name={mapSocialPlatformToIcon(socialAccount.platform)}
          />
        </div>
        <div>
          <Text
            variant="subtitle2"
            className={cn({ [styles.disabled]: disabled })}
          >
            {mapSocialPlatformToLabel(socialAccount.platform)}
          </Text>
          <Text
            variant="body2Regular"
            color="lights-low"
            className={cn({ [styles.disabled]: disabled })}
          >
            {socialAccount.link}
          </Text>
        </div>
      </div>
      <button
        type="button"
        className={styles.removeButton}
        onClick={onRemove}
        disabled={disabled}
      >
        <MillionsIcon
          name={useOldIcon ? 'minus' : 'trash'}
          className={cn(styles.removeIcon, { [styles.disabled]: disabled })}
        />
      </button>
    </div>
  );
};

export default SocialsRow;
